import { AnaColumn } from "../forms-template.service";
import { aspect } from "./aspect";
import { createGridConfig, gridMultiple, gridSimple } from "./gridSettings/gridSettings";
import { sedeForm } from "./sedeForm";
import { soggetto } from "./soggetto";
export const lettereAlfabeto = "a b c d e f g h i j k l m n o p q r s t u v w x y z".split(' ');//SOGGETTO == SEDE

const empty = { type: 'empty', dataField: '', dataType: '' }

const UL_stato = {
  orderGriglia: 8,
  type: 'campoSpecial', dataField: "UL_stato", dataType: "", caption: "Stato",
  colVisible: false,
  nCol:3, 
  colSpan:5,
  labelWidth:90,
  lista: {
    dataSource: 'statoEstero',
    valueExpr: 'iso',
    displayExpr: 'descrizione',
     static: false

  },
  
  editorType: 'dxSelectBox'
}

const uL_ElaboraMud = {
  type: 'campoSpecial', colVisible: false, dataField: "elaboraMud", editorType: "dxSelectBox",
  caption: "Elabora MUD",
  nCol: 3,
  labelWidth: 120,
  lista: {
    dataSource: 'elaboraMUD',
    valueExpr: 'id',
    displayExpr: 'descrizione',
    static: true,
    items: [
      {
        id: 'S', descrizione: 'SI'
      },
      {
        id: 'N', descrizione: 'NO'
      }
    ]
  }
}

const uL_TipoMud = {
  type: 'campoSpecial', colVisible: false, dataField: "tipoMud", dataType: "", caption: "Tipo Mud",
  editorType: "dxSelectBox",
  maxLength: "3",
  maxSize: 1,

  nCol: 4,
  lista: {
    dataSource: 'tipoMUD',
    valueExpr: 'id',
    displayExpr: 'descrizione',
    static: true
  }
}

const gruppo_3 = {
  
   
    itemType: "group", caption: "Opzioni di Stampa", colCount: "2", class: 'w-100 mt-4 mb-4', data: [
      

      {
        type: 'campoSpecial', colVisible: false,
        dataField: "nonEscludiMovimentatiCheckBox",
        editorType: "dxCheckBox",
        caption: 'Escludi Non Movim.',
        maxLength: "1",
        maxSize: 1,
        labelWidth:150,
        disabled:true,
        
      },

      {
        type: 'campoSpecial',
        colVisible: false,
        labelWidth:150,
        dataField: "escludiMovimentatiCheckBox",
        editorType: "dxCheckBox",
        caption: 'Escludi Movimentati',
       
        maxLength: "1",
        maxSize: 1,
      
        disabled:true,
      },

     /*  {
        type: 'campoSpecial',
        colVisible: false,
        labelWidth:150,
        dataField: "tipoRicerca",
        caption: 'Tipo di ricerca',
        colSpan:2,
        maxLength: "1",
        editorType: 'dxRadioGroup',
        radioGroup: {

          dataSource: '',
          valueExpr: 'value',
          displayExpr: 'descrizione',
          layout: 'horizontal',
          static: true,

          items: [
            {
              icon: 'glyphicon icon-unlocked',
              value: 'AND',
              descrizione: 'AND',
              alignment: 'center',
            },
            {
              icon: 'glyphicon icon-locked',
              value: 'OR',
              descrizione: 'OR',
              alignment: 'center',
            },


          ]
        }
      }, */
    ]
  
}

// Questo form è composto da soggetti + sede
let soggettoMd:AnaColumn[] = JSON.parse(JSON.stringify(soggetto));

let gruppo1 = soggettoMd[1]
let gruppo2 = soggettoMd[2]



let unicopGruppoData = gruppo1.data.concat(gruppo2.data);

//let soggettoMdG = unicopGruppoData
soggettoMd[1].data = unicopGruppoData;

soggettoMd.splice(2,1)

let sediMd = JSON.parse(JSON.stringify(sedeForm));
sediMd = sediMd.filter(reeeeeee=>reeeeeee.itemType == 'group')
const configuration = {
  configuration:
  {
    titleGriglia: 'Filtri Avanzati',
    titleForm: '$filtriavanzati',
    breadcrumbCaption: 'Filtri Avanzati',
    campoTitle: ['filtriAvanzati'],
    masterKey: 'id',
    service: 'nomeTemplate',
    api: 'nomeTemplate',
    filterList: '?NomeTabella=$NomeTabella&IdTabella=$IdTabella',
    helpDoc: '#',
    queryFilter: [],
    filterEditor: '/$',
    formType: 'simple',
    idTabRif: [],
    nCol: 1,
  }
}

sediMd = sediMd.filter((resColS,x) => {
    
    let colSpanG = 0;
   
    
    colSpanG = Number(resColS.colCount)
    
  
    const newDataS = []; // Nuovo array per contenere i dati con l'aggiunta
    resColS.data.forEach(di => {
    
    const colSpan = Number(di.colSpan);

    if(di.type == 'empty' && di.caption > " " && colSpan  ==  colSpanG){
       di.dataField ='emptyno'
    } 

    switch (di.dataField) {
      case 'riferimentoEsterno':
        di = empty
        newDataS.push(uL_ElaboraMud)
        newDataS.push(uL_TipoMud)
        newDataS.push(empty)
        newDataS.push(empty)
        newDataS.push(empty)
      break
      case 'emptyno':
        di = null
       case 'civico': 
       case 'istatComune': 
       case 'numeroIscrizioneAlbo':
       case 'protocolloAlbo':
       case 'dataIscrizioneAlbo':
       case 'copiaDatiAzienda':
       case 'descrizione':
       case 'indirizzo':
       case 'frazione':
       case 'riferimentoEsterno':
       case 'nota':
       case 'tipoMud':
       case 'cciiaa':
       case 'ateco':
       case 'rea':
       case 'addetti':
       case 'mesiAttivita':
       case 'rappresentanteNome':
       case 'rappresentanteCognome':
       case 'idSedeRentri':
       case 'latidudine':
       case 'longitudine':
        di = empty
       break;
       case 'idCategoria':
       case 'idTipo':
       case 'idZona':
        di.dynamic.settingGrid = gridMultiple;
        break;
       
      default:
        delete di.validation;
        delete di.labelWidth;
     break;
    }
    if(di){

      newDataS.push(di); // Aggiungi l'elemento corrente a newData
    }
  });

  resColS.data = newDataS; // Assegna il nuovo array di dati modificati a resCol.data
  return true; // Restituisci true per mantenere resCol nell'array filtrato
})


sediMd[1] = gruppo_3
soggettoMd = soggettoMd.concat(sediMd)

soggettoMd = soggettoMd.filter((resCol,z) => {
  resCol.caption = '';
 
  let colSpanG = 0;
  if(z == 1){
    colSpanG = resCol.colCount;
    resCol.groupWidth=750
    resCol.caption = 'Dati Azienda';
  }

  
  if(z == 2 ){
    colSpanG = resCol.colCount;
    resCol.caption = 'Dati UL';
    resCol.groupWidth=750
  }

  
  if(z > 3){
    return false;
  }

  if (typeof resCol.data !== 'undefined') {
    const newData = []; // Nuovo array per contenere i dati con l'aggiunta

    resCol.data.forEach(d => {
      if(d.type == 'empty' && d.nCol >0){
        delete d.nCol
      }

      //Cambia ncol al gruppo 1 soggetto
      if(z == 1 && d.dataField != "" && d.nCol == 5 ){
          d.nCol = 7
          d.dataField = 'SD_' + d.dataField;  
      }

       
      //Cambia dataField al gruppo  relativo a sede
      if(z >= 2 && d.dataField != ""){
        d.dataField =  'UL_' + d.dataField;
      }

      switch (d.dataField) {
        case 'codiceFiscale':
        case 'partitaIVA':
        case 'titolo':
        case 'isoFiscale':
        case 'civico':
        case 'istatComune':
          d = empty;
        break
        case 'idZona':
        case 'idCategoria':
          d.dynamic.settingGrid = gridMultiple;
          //d.labelWidth = 120;
          d.dataField = 'SD_' + d.dataField;  
          break;
          case 'UL_comune':
            d.labelWidth =90
            d.dynamic.related = ['cap|UL_cap', 'siglaProvincia|UL_siglaProvincia']
          break;
          case 'cap':   
            d.nCol=3;
            d.width=35 
            d.dataField = 'SD_' + d.dataField;  
          break
          case 'siglaProvincia':
              d.dataField = 'SD_' + d.dataField;  
             d.nCol=4 
          break
          case 'UL_stato':
            d = null
            break
          case 'UL_idZona':
            
            newData.push(UL_stato)
            break;
            case 'UL_dataChiusuraImpiantoMobile':
              d.disableOnUpdate = false;
              d.disabled = false;
             // d.labelWidth=160
              break;
        default:
          if(z<= 2){
            d.labelWidth = 90;
          }
            
          delete d.validation;
          
        break;
      }
      if(d){

        newData.push(d); // Aggiungi l'elemento corrente a newData
      }
    });

    resCol.data = newData; // Assegna il nuovo array di dati modificati a resCol.data
    return true; // Restituisci true per mantenere resCol nell'array filtrato
  }

  return false; // Se resCol.data non è definito, restituisci false per escludere resCol dall'array filtrato
});


soggettoMd.unshift(configuration)



export const  soggettiFiltri = soggettoMd

//console.log('soggettiFiltri',JSON.stringify(soggettiFiltri));

 export const soggettiFiltriOld: AnaColumn[] = [
  {
    configuration:
    {
      titleGriglia: 'Filtri Avanzati',
      titleForm: '$filtriavanzati',
      breadcrumbCaption: 'Filtri Avanzati',
      campoTitle: ['filtriAvanzati'],
      masterKey: 'id',
      service: 'nomeTemplate',
      api: 'nomeTemplate',
      filterList: '?NomeTabella=$NomeTabella&IdTabella=$IdTabella',
      helpDoc: '#',
      queryFilter: [],
      filterEditor: '/$',
      formType: 'simple',
      idTabRif: [],
      nCol: 2,
    }
  },
  {
    //IL COLSPAN È RIFERITO ALLA PROPRIETA NGCOL
    itemType: "group", caption: "Sede Legale", colCount: "4", class: 'w-100 mt-4 mb-4', data: [
      {
        type: 'campo', nCol: 5, labelWidth: 120, dataField: "sD_RagioneSociale", dataType: "campoSpecial", caption: "Rag. Sociale",
      },
      {
        type: 'campoSpecial', colVisible: true, dataField: "sD_Categoria_Descrizione",
        dataType: "campoSpecial",
        nCol: 5,
        caption: "Categoria",
        labelWidth: 120,
        editorType: '',
        dynamic: {

          dataSource: 'Categoria',
          service: 'generic',
          autocomplete: false,

          valueExpr: '',//Lasciato Vuoto sen non serve l'id del DB
          displayExpr: 'descrizione',
          caption: "Categoria",
          queryString: '?nomeTabella=SOGGETTI',
          componentType: 'dynamicGrid',
          //related: ['cap', 'siglaProvincia', 'id|istatComune'],
          related: ['id|sD_IdCategoria'],
          buttonOption: {
            text: 'Regione',
            icon: 'glyphicon mdi mdi-playlist-plus',
            hint: 'Sfoglia Stati',
            name: 'Regione',
            location: 'after',
          },
          settingGrid: gridSimple,
        },
      },
      { type: 'empty', dataField: '', dataType: '' },
      { type: 'empty', dataField: '', dataType: '' },
      {
        type: 'campoSpecial', dataField: "sD_Regione_Descrizione", dataType: "", caption: "Regione",
        
        colVisible: false,
        nCol: 2,
        labelWidth: 120,
        disableOnUpdate: false,
      
        dynamic: {
         
          service: 'generic',
          dataSource: 'regione',
          autocomplete: false,
          
          valueExpr: '',//Lasciato Vuoto sen non serve l'id del DB
          displayExpr: 'descrizione',
          caption: "Regione",
          queryString: '?$orderby=Descrizione asc',
          componentType: 'dynamicGrid',
          related: ['cap', 'siglaProvincia', 'id|sD_IdRegione'],
          
          buttonOption: {
            text: 'Regione',
            icon: 'glyphicon mdi mdi-playlist-plus',
            hint: 'Sfoglia Stati',
            name: 'Regione',
            location: 'after',
          },
          settingGrid: gridSimple,
        },
      },
      {
        type: 'campoSpecial', dataField: "sD_Comune", caption: "Comune", dataType: "campoSpecial",
        colVisible: true,
        maxSize: 45,
        nCol: 3,
        labelWidth: 100,
        dynamic: {
          costantValue: [{ key: 'stato', value: 'IT' }],
          service: 'comune',
          dataSource: 'comune',
          autocomplete: false,
          checkValue: {
            checkValueMessage: 'Comune inesistente, vuoi continuare?',
            forceInsert: true
          },
          valueExpr: '',//Lasciato Vuoto sen non serve l'id del DB
          displayExpr: 'descrizione',
          caption: "Comuni",
          queryString: '?$orderby=Descrizione asc',
          componentType: 'dynamicGrid',
          //related: ['cap', 'siglaProvincia', 'id|istatComune'],
          enableEditor: {
            add: false,
            remove: false,
            update: false
          },
          buttonOption: {
            text: 'Comuni',
            icon: 'glyphicon mdi mdi-playlist-plus',
            hint: 'Sfoglia Comuni',
            name: 'Comuni',
            location: 'after',
          },
          settingGrid: createGridConfig({
            ...gridSimple,
            colonne: [
              { type: 'campo', dataField: "id", dataType: "string", caption: "ISTAT", colWidth: '55' },
              { type: 'campo', dataField: "descrizione", dataType: "", caption: "Comune", colWidth: '300' },
              { type: 'campo', dataField: "siglaProvincia", dataType: "string", caption: "PR.", colWidth: '40' },
              { type: 'campo', dataField: "cap", dataType: "string", caption: "CAP", colWidth: '70' },
            ]
          })
        }
      },
      {
        type: 'campo', colVisible: true, dataField: "sD_Zona_Descrizione",
        dataType: "campo",
        nCol: 5,
        labelWidth: 120,
        caption: "Zona",
        editorType: '',
        dynamic: {

          dataSource: 'Zona',
          service: 'generic',
          autocomplete: false,

          valueExpr: '',//Lasciato Vuoto sen non serve l'id del DB
          displayExpr: 'descrizione',
          caption: "Categoria",
          queryString: '?nomeTabella=soggetti',
          componentType: 'dynamicGrid',
          //related: ['cap', 'siglaProvincia', 'id|istatComune'],

          buttonOption: {
            text: 'Regione',
            icon: 'glyphicon mdi mdi-playlist-plus',
            hint: 'Sfoglia Stati',
            name: 'Regione',
            location: 'after',
          },
          settingGrid: gridSimple,
        },
      },
      { type: 'empty', dataField: '', dataType: '' },
     
      { type: 'empty', dataField: '', dataType: '' },
      { type: 'empty', dataField: '', dataType: '' },
      {
        type: 'campo', nCol: 2, labelWidth: 120, dataField: "sD_CAP", dataType: "campoSpecial", caption: "CAP",
      },
      {
        type: 'campoSpecial', dataField: "sD_SiglaProvincia", caption: "Provincia",
        nCol: 3,
        labelWidth: 100,
        editorType: "dxSelectBox", maxLength: "2",
        colVisible: true, colWidth: '88',
        showInColumnChooser: true,
        allowHiding: false,
        lista: {
          dataSource: 'provincia',
          valueExpr: 'siglaProvincia',
          displayExpr: 'descrizione',
          static: false,
        }
      },
      {

        type: 'campoSpecial', colVisible: false, dataField: "sD_Stato", dataType: "", caption: "Stato",
        maxLength: '2', maxSize: 40, nCol:2, labelWidth:120,
       
        lista: {
          dataSource: 'statoEstero',
          valueExpr: 'iso',
          displayExpr: 'descrizione',
          static: false
        },
        editorType: 'dxSelectBox'
      },
   
      { type: 'empty', dataField: '', dataType: '' },
      { type: 'empty', dataField: '', dataType: '' },
     
      { type: 'empty', dataField: '', dataType: '' },
     
      { type: 'empty', dataField: '', dataType: '' },
   
    ]
  },
  {
    //IL COLSPAN È RIFERITO ALLA PROPRIETA NGCOL
    itemType: "group", caption: "Unità Locale", colCount: "6", class: 'w-100 mt-4 mb-4', data: [
      {
        type: 'campo', nCol: 1, labelWidth: 120, dataField: "ul_IsProduttore", dataType: "boolean", caption: "Produttore", editorType: "dxCheckBox", colVisible: false,
      },
      {
        type: 'campo', nCol: 1, labelWidth: 120, dataField: "ul_IsTrasportatore", dataType: "boolean", caption: "Trasportatore", editorType: "dxCheckBox", colVisible: false,
      },
      {
        type: 'campo', nCol: 1, labelWidth: 120, dataField: "ul_IsDestinatarioRifiuto", dataType: "boolean", caption: "Destinatario", editorType: "dxCheckBox", colVisible: false,
      },
      {
        type: 'campo', labelWidth: 120, nCol: 2, dataField: "ul_IsIntermediario", dataType: "boolean", caption: "Intermediario", editorType: "dxCheckBox", colVisible: false,
      },
      {
        type: 'campoSpecial', colVisible: false, dataField: "uL_ElaboraMud", editorType: "dxSelectBox",
        caption: "Elabora MUD",
        nCol: 2,
        labelWidth: 120,
        //class: 'text-uppercase',
        lista: {
          dataSource: 'elaboraMUD',
          valueExpr: 'id',
          displayExpr: 'descrizione',
          static: true,
          items: [
            {
              id: 'S', descrizione: 'SI'
            },
            {
              id: 'N', descrizione: 'NO'
            }
            /*,
            {
              id:'TUTTI',descrizione: 'Tutti'
            },
            */
          ]
        }
      },
      {
        type: 'campoSpecial', colVisible: false, dataField: "uL_TipoMud", dataType: "", caption: "Tipo Mud",
        editorType: "dxSelectBox",
        maxLength: "3",
        maxSize: 1,
        labelWidth: 100,
        //class: 'text-uppercase',
        horizontalAlignment: 'left',
        nCol: 3,
        lista: {
          dataSource: 'tipoMUD',
          valueExpr: 'id',
          displayExpr: 'descrizione',
          static: true
        }
      },
      {
        type: 'campoSpecial', colVisible: false, dataField: "uL_TipoPCE",
        caption: "Tipo Azienda",
        maxLength: "2",
        maxSize: 2,
        labelWidth: 120,
        nCol: 5,
        hideOnEdit: false,
        editorType: 'dxSelectBox',
        //class: 'text-uppercase',
        lista: {
          dataSource: 'tipoPCE',
          valueExpr: 'id',
          displayExpr: 'descrizione', static: true
        },
      },
      {
        type: 'campoSpecial', colVisible: true, dataField: "uL_Zona_Descrizione",
        dataType: "campoSpecial",
        nCol: 5,
        caption: "Categoria",
        labelWidth: 120,
        editorType: '',
        dynamic: {

          dataSource: 'Categoria',
          service: 'generic',
          autocomplete: false,

          valueExpr: '',//Lasciato Vuoto sen non serve l'id del DB
          displayExpr: 'descrizione',
          caption: "Categoria",
          queryString: '?nomeTabella=SEDI',
          componentType: 'dynamicGrid',
          related: ['id|uL_IdCategoria'],

          buttonOption: {
            text: 'Categorie',
            icon: 'glyphicon mdi mdi-playlist-plus',
            hint: 'Sfoglia Stati',
            name: 'Categorie',
            location: 'after',
          },
          settingGrid: gridSimple,
        },
      },
     
    
      { type: 'empty', dataField: '', dataType: '' },
      { type: 'empty', dataField: '', dataType: '' },
      { type: 'empty', dataField: '', dataType: '' },
      { type: 'empty', dataField: '', dataType: '' },
      {
        type: 'campoSpecial', dataField: "uL_Regione_Descrizione", dataType: "", caption: "Regione",
        
        colVisible: false,
        nCol: 3,
        labelWidth: 120,
        disableOnUpdate: false,
      
        dynamic: {
         
          service: 'generic',
          dataSource: 'regione',
          autocomplete: false,
          
          valueExpr: '',//Lasciato Vuoto sen non serve l'id del DB
          displayExpr: 'descrizione',
          caption: "Regione",
          queryString: '?$orderby=Descrizione asc',
          componentType: 'dynamicGrid',
          related: ['cap', 'siglaProvincia', 'id|uL_IdRegione'],
          
          buttonOption: {
            text: 'Regione',
            icon: 'glyphicon mdi mdi-playlist-plus',
            hint: 'Sfoglia Stati',
            name: 'Regione',
            location: 'after',
          },
          settingGrid: gridSimple,
        },
      },
      {
        type: 'campoSpecial', dataField: "uL_SiglaProvincia", caption: "Provincia",
        nCol: 2,
        labelWidth: 120,
        editorType: "dxSelectBox", maxLength: "2",
        colVisible: true, colWidth: '88',
        showInColumnChooser: true,
        allowHiding: false,
        lista: {
          dataSource: 'provincia',
          valueExpr: 'siglaProvincia',
          displayExpr: 'descrizione',
          static: false,
        }
      },
     
      {
        type: 'campoSpecial', colVisible: true, dataField: "uL_Zona_Descrizione",
        dataType: "",
        nCol: 5,
        labelWidth: 120,
        caption: "Zona",
       
        editorType: '',
        dynamic: {

          dataSource: 'Zona',
          service: 'zona',
          autocomplete: false,

          valueExpr: '',//Lasciato Vuoto sen non serve l'id del DB
          displayExpr: 'descrizione',
          caption: "Zona",
          queryString: '?nomeTabella=Sedi',
          componentType: 'dynamicGrid',
          //related: ['cap', 'siglaProvincia', 'id|istatComune'],

          buttonOption: {
            text: 'Zone',
            icon: 'glyphicon mdi mdi-playlist-plus',
            hint: 'Sfoglia Stati',
            name: 'Zone',
            location: 'after',
          },
          settingGrid: gridSimple,
        },
      },
      { type: 'empty', dataField: '', dataType: '' },
      { type: 'empty', dataField: '', dataType: '' },
      { type: 'empty', dataField: '', dataType: '' },
      {
        type: 'campoSpecial', dataField: "uL_Comune", caption: "Comune", dataType: "",
        colVisible: true,
        labelWidth: 120,
        maxSize: 45,
        nCol: 3,
        dynamic: {
          costantValue: [{ key: 'stato', value: 'IT' }],
          service: 'comune',
          dataSource: 'comune',
          autocomplete: false,
          checkValue: {
            checkValueMessage: 'Comune inesistente, vuoi continuare?',
            forceInsert: true
          },
          valueExpr: '',//Lasciato Vuoto sen non serve l'id del DB
          displayExpr: 'descrizione',
          caption: "Comuni",
          queryString: '?$orderby=Descrizione asc',
          componentType: 'dynamicGrid',
          //related: ['cap', 'siglaProvincia', 'id|istatComune'],
          enableEditor: {
            add: false,
            remove: false,
            update: false
          },
          buttonOption: {
            text: 'Comuni',
            icon: 'glyphicon mdi mdi-playlist-plus',
            hint: 'Sfoglia Comuni',
            name: 'Comuni',
            location: 'after',
          },
          settingGrid: createGridConfig({
            ...gridSimple,
            colonne: [
              { type: 'campo', dataField: "id", dataType: "string", caption: "ISTAT", colWidth: '55' },
              { type: 'campo', dataField: "descrizione", dataType: "", caption: "Comune", colWidth: '300' },
              { type: 'campo', dataField: "siglaProvincia", dataType: "string", caption: "PR.", colWidth: '40' },
              { type: 'campo', dataField: "cap", dataType: "string", caption: "CAP", colWidth: '70' },
            ]
          })
        }
      
      },
      
     
    
      { type: 'empty', nCol:2, dataField: '', dataType: '' },
      { type: 'empty', dataField: '', dataType: '' },
      { type: 'empty', dataField: '', dataType: '' },
      { type: 'empty', dataField: '', dataType: '' },
      {
        type: 'campoSpecial', colVisible: true, dataField: "uL_IdTipo",
        dataType: "",
        nCol: 5,
        caption: "Tipo",
        labelWidth: 120,
        editorType: '',

        dynamic: {
          autocomplete: false,
          dataSource: 'tipo?nomeTabella=SEDI',
          displayExpr: 'descrizione',
          queryString: '?nomeTabella=SEDI',
          valueExpr: 'id',
          static: false,
          settingGrid: {
            colonne: [
              { dataField: 'descrizione', caption: 'Nome Tipo', dataType: '' }
            ]
          }
        },

      },
      { type: 'empty', dataField: '', dataType: '' },
      { type: 'empty', dataField: '', dataType: '' },
      { type: 'empty', dataField: '', dataType: '' },
    ]
  },
  {
    //IL COLSPAN È RIFERITO ALLA PROPRIETA NGCOL
    itemType: "group", caption: "Opzioni di Stampa", colCount: "2", class: 'w-100 mt-4 mb-4', data: [
      {
        type: 'campoSpecial', colVisible: false,
        dataField: "nonEscludiMovimentatiCheckBox",
        editorType: "dxCheckBox",
        caption: 'Escludi Non Movim.',
        //width: 5 + 'vw',
        maxLength: "1",
        maxSize: 1,
        labelWidth:140,
        disabled:true,
        nCol: 2,
      },

      {
        type: 'campoSpecial',
        colVisible: false,
        labelWidth:120,
        dataField: "escludiMovimentatiCheckBox",
        editorType: "dxCheckBox",
        caption: 'Escludi Movimentati',
        //width: 5 + 'vw',
        maxLength: "1",
        maxSize: 1,
        nCol: 2,
        disabled:true,
      },
    ]
  }
] 